// extracted by mini-css-extract-plugin
module.exports = {"insideScoop":"styles_insideScoop__jRxdJ"};